module.exports = __webpack_public_path__ + "img/bottom.07ad8361.jpg";